import { Component } from '@angular/core';

@Component({
  selector: 'app-platform-not-supported',
  templateUrl: './platform-not-supported.component.html',
  styleUrls: [ './platform-not-supported.component.scss' ]
})

export class PlatformNotSupportedComponent {}
